import React from 'react';
import cn from 'classnames';

export interface StepCounterProps {
  /** Current step number. Displayed zero-padded to 2 digits (e.g. 1 → "01"). */
  current: number;
  /** Total number of steps (displayed as "of N"). */
  total: number;
  className?: string;
}

export const StepCounter: React.FC<StepCounterProps> = ({ current, total, className }) => (
  <div className={cn('flex flex-col gap-5 items-end', className)}>
    <div className="flex flex-col gap-3 items-end shrink-0">
      <span className="text-ds-display font-light text-ds-text-inverse-3">
        {String(current).padStart(2, '0')}
      </span>
      {/* Accent bar */}
      <span className="w-6 h-1 rounded-1 shrink-0 bg-ds-bg-surface-2" />
    </div>
    <span className="text-ds-text-s font-semibold text-ds-text-4">of {total}</span>
  </div>
);

export default StepCounter;
